/**
 * @Author: wuyang
 * @Date: 2024/2/5
 * @Description: ""
 */
import { EventBusService } from '@/helper/services/event-bus/EventBusService'
import { createSocketService } from '@/helper/services/socket/SocketService'
import { ESocketPushType } from '@/types/socket'

export const eventBusService = (() => {
	const socketService = createSocketService({})
	const eventBus = new EventBusService({})
	socketService.on(ESocketPushType.k4Image, (result) => {
		const ordinal = result.ordinalImgResultList[0]
		if (ordinal) {
			eventBus.update4kImage(ordinal.imageId, ordinal)
		}
	})
	return eventBus
})()
